import React, { Component }  from 'react';
export default (props) => { 
    let {data} = props;
    return (
        <div className="lineStyle" dangerouslySetInnerHTML={{__html:data}} />
    ) 
}



// WEBPACK FOOTER //
// ./src/components/Journals/Details/Layouts/Components/bullet.js